import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';


@autoinject()
export class DemoPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////



    ////****************** Element References ***************************************////



    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }
    //protected async activate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {}
    //protected created(owningView: View, myView: View): void { }
    //protected bind(bindingContext: Object, overrideContext: Object): void { }
    //protected attached(): void { }
    //protected deactivate(): void { }
    //protected detached(): void { }
    //protected unbind(): void { }



    ////****************** Events ***************************************************////



    ////****************** Functions ************************************************////



    ////****************** Service Calls ********************************************////

}
